var _style, _circle, _circle2, _path, _circle3, _path2, _circle4, _path3, _circle5, _path4, _circle6, _path5, _circle7, _path6, _circle8, _path7, _circle9, _path8, _circle0, _path9, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMulticlock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:30.2177;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:10.0369;stroke-miterlimit:10;}\r\n\t.st2{stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 512,
    cy: 512,
    r: 388.87
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 512.17,
    cy: 512,
    r: 73.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512.17,463.91c0.3,1.04,0.57,1.99,0.84,2.95c3.81,13.32,7.61,26.64,11.43,39.96c0.91,3.17,0.84,6.28-0.57,9.28 c-1.97,4.2-5.29,6.73-9.88,7.44c-6.47,1.01-12.75-3.27-14.3-9.65c-0.52-2.13-0.55-4.26,0.04-6.38c1.03-3.72,2.1-7.43,3.16-11.14 c2.35-8.24,4.71-16.48,7.07-24.72C510.69,469.1,511.42,466.54,512.17,463.91z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 319.37,
    cy: 512,
    r: 73.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.37,463.91c0.3,1.04,0.57,1.99,0.84,2.95c3.81,13.32,7.61,26.64,11.43,39.96c0.91,3.17,0.84,6.28-0.57,9.28 c-1.97,4.2-5.29,6.73-9.88,7.44c-6.47,1.01-12.75-3.27-14.3-9.65c-0.52-2.13-0.55-4.26,0.04-6.38c1.03-3.72,2.1-7.43,3.16-11.14 c2.35-8.24,4.71-16.48,7.07-24.72C317.89,469.1,318.62,466.54,319.37,463.91z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 704.97,
    cy: 512,
    r: 73.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M704.97,463.91c0.3,1.04,0.57,1.99,0.84,2.95c3.81,13.32,7.61,26.64,11.43,39.96c0.91,3.17,0.84,6.28-0.57,9.28 c-1.97,4.2-5.29,6.73-9.88,7.44c-6.47,1.01-12.75-3.27-14.3-9.65c-0.52-2.13-0.55-4.26,0.04-6.38c1.03-3.72,2.1-7.43,3.16-11.14 c2.35-8.24,4.71-16.48,7.07-24.72C703.49,469.1,704.22,466.54,704.97,463.91z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 512.52,
    cy: 704.8,
    r: 73.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512.52,656.71c0.3,1.04,0.57,1.99,0.84,2.95c3.81,13.32,7.61,26.64,11.43,39.96c0.91,3.17,0.83,6.28-0.57,9.28 c-1.97,4.2-5.29,6.73-9.88,7.44c-6.47,1.01-12.75-3.27-14.3-9.65c-0.52-2.13-0.55-4.26,0.04-6.38c1.03-3.72,2.1-7.43,3.16-11.14 c2.35-8.24,4.71-16.48,7.07-24.72C511.03,661.9,511.77,659.35,512.52,656.71z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 319.72,
    cy: 704.8,
    r: 73.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.72,656.71c0.3,1.04,0.57,1.99,0.84,2.95c3.81,13.32,7.61,26.64,11.43,39.96c0.91,3.17,0.84,6.28-0.57,9.28 c-1.97,4.2-5.29,6.73-9.88,7.44c-6.47,1.01-12.75-3.27-14.3-9.65c-0.52-2.13-0.55-4.26,0.04-6.38c1.03-3.72,2.1-7.43,3.16-11.14 c2.35-8.24,4.71-16.48,7.07-24.72C318.23,661.9,318.96,659.35,319.72,656.71z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 704.28,
    cy: 704.8,
    r: 73.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M704.29,656.71c0.3,1.04,0.57,1.99,0.84,2.95c3.81,13.32,7.61,26.64,11.43,39.96c0.91,3.17,0.83,6.28-0.57,9.28 c-1.97,4.2-5.29,6.73-9.88,7.44c-6.47,1.01-12.75-3.27-14.3-9.65c-0.52-2.13-0.55-4.26,0.04-6.38c1.03-3.72,2.1-7.43,3.16-11.14 c2.35-8.24,4.71-16.48,7.07-24.72C702.8,661.9,703.53,659.35,704.29,656.71z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 511.48,
    cy: 319.2,
    r: 73.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M511.49,271.11c0.3,1.04,0.57,1.99,0.84,2.95c3.81,13.32,7.61,26.64,11.43,39.96c0.91,3.17,0.84,6.28-0.57,9.28 c-1.97,4.2-5.29,6.73-9.88,7.44c-6.47,1.01-12.75-3.27-14.3-9.65c-0.52-2.13-0.55-4.26,0.04-6.38c1.03-3.72,2.1-7.43,3.16-11.14 c2.35-8.24,4.71-16.48,7.07-24.72C510,276.3,510.73,273.74,511.49,271.11z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 319.37,
    cy: 319.2,
    r: 73.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.37,271.11c0.3,1.04,0.57,1.99,0.84,2.95c3.81,13.32,7.61,26.64,11.43,39.96c0.91,3.17,0.84,6.28-0.57,9.28 c-1.97,4.2-5.29,6.73-9.88,7.44c-6.47,1.01-12.75-3.27-14.3-9.65c-0.52-2.13-0.55-4.26,0.04-6.38c1.03-3.72,2.1-7.43,3.16-11.14 c2.35-8.24,4.71-16.48,7.07-24.72C317.89,276.3,318.62,273.74,319.37,271.11z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 704.28,
    cy: 319.2,
    r: 73.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M704.29,271.11c0.3,1.04,0.57,1.99,0.84,2.95c3.81,13.32,7.61,26.64,11.43,39.96c0.91,3.17,0.83,6.28-0.57,9.28 c-1.97,4.2-5.29,6.73-9.88,7.44c-6.47,1.01-12.75-3.27-14.3-9.65c-0.52-2.13-0.55-4.26,0.04-6.38c1.03-3.72,2.1-7.43,3.16-11.14 c2.35-8.24,4.71-16.48,7.07-24.72C702.8,276.3,703.53,273.74,704.29,271.11z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulticlock1);
export default __webpack_public_path__ + "static/media/multiclock1.e0ba5e230103168c1516857b533624bb.svg";
export { ForwardRef as ReactComponent };